"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1154],{

/***/ 5553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7149);






var BreadCrumbs = function(props) {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), breadcrumbs = ref1[0], setBreadcrumbs = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), lastCrumb = ref2[0], setLastCrumb = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), offerPageName = ref3[0], setOfferPageName = ref3[1];
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var last = [];
    var evaluateBreadCrumb = function(value) {
        var breadCrumbValue = value && value[0] && value[0].href;
        switch(true){
            case (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("portable-storage")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("residential")) || (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("entreposage-mobile")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("residentiel")):
                if (locale === "en") {
                    last[0].label = "Residential Portable Storage";
                } else {
                    last[0].label = "Entreposage mobile r\xe9sidentiel";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("portable-storage")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("business")) || (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("entreposage-mobile")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("commercial")):
                if (locale === "en") {
                    last[0].label = "Portable Storage Containers for Business";
                } else {
                    last[0].label = "Conteneurs mobiles pour entreposage commercial";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/portable-storage/moving" || breadCrumbValue === "/entreposage-mobile/demenagement"):
                if (locale === "en") {
                    last[0].label = "Portable Storage for Moving";
                } else {
                    last[0].label = "Entreposage mobile pour d\xe9m\xe9nager";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("portable-storage")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("long-distance-moving")) || (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("entreposage-mobile")) && (breadCrumbValue === null || breadCrumbValue === void 0 ? void 0 : breadCrumbValue.includes("demenagement-longue-distance")):
                if (locale === "en") {
                    last[0].label = "Long Distance Moving";
                } else {
                    last[0].label = "D\xe9m\xe9nagement sur longue distance";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/packing-supplies" || breadCrumbValue === "/fournitures-emballage"):
                if (locale === "en") {
                    last[0].label = "Packing Supplies";
                } else {
                    last[0].label = "Fournitures de d\xe9m\xe9nagement et d'emballage";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/self-storage/business" || breadCrumbValue === "/entreposage-libre-service/commercial"):
                if (locale === "en") {
                    last[0].label = "Business Self Storage";
                } else {
                    last[0].label = "Entreposage commercial en libre-service";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/self-storage/moving" || breadCrumbValue === "/entreposage-libre-service/demenagement"):
                if (locale === "en") {
                    last[0].label = "Moving Storage";
                } else {
                    last[0].label = "Entreposage mobile";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/terms-of-service" || breadCrumbValue === "/conditions-dutilisation"):
                if (locale === "en") {
                    last[0].label = "User Agreement";
                } else {
                    last[0].label = "ENTENTE SUR LES CONDITIONS D’UTILISATION";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            case breadCrumbValue && (breadCrumbValue === "/careers" || breadCrumbValue === "/carrieres"):
                if (locale === "en") {
                    last[0].label = "Careers";
                } else {
                    last[0].label = "Carrieres";
                }
                setLastCrumb(function(val) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, val), {
                        label: last[0].label
                    });
                });
                break;
            default:
                break;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var pageName =  true && window.location.pathname.split("/");
        var pathWithoutQuery;
        if (pageName[2] === "offers" || pageName[2] === "offres" || pageName[2] === "blogue" || pageName[2] === "blog") {
            setOfferPageName(pageName[2]);
            pathWithoutQuery = "/".concat(pageName[2], "/").concat(pageName[3]);
        } else {
            pathWithoutQuery = locale === "en" ? props.path :  true && window.location.href.split("fr")[1];
        }
        pathWithoutQuery = pathWithoutQuery === null || pathWithoutQuery === void 0 ? void 0 : pathWithoutQuery.replace("#form", "");
        var pathArray = pathWithoutQuery === null || pathWithoutQuery === void 0 ? void 0 : pathWithoutQuery.split("/");
        if (locale === "en") {
            pathArray.shift();
        }
        pathArray = pathArray === null || pathArray === void 0 ? void 0 : pathArray.filter(function(path) {
            return path !== "" && !path.startsWith("?");
        });
        var breadcrumb = pathArray === null || pathArray === void 0 ? void 0 : pathArray.map(function(path, index) {
            return {
                href: "/".concat(pathArray.slice(0, index + 1).join("/")),
                label: path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, " ")
            };
        });
        last = breadcrumb.slice(-1);
        setLastCrumb(last);
        breadcrumb.splice(breadcrumb.length - 1, 1);
        setBreadcrumbs(breadcrumb);
        evaluateBreadCrumb(last);
    }, [
        router.asPath,
        locale,
         true && window.location.href, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: props.isNoMargin ? "container container-no-margin" : "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: "sv-breadcrumb",
                children: [
                    locale === "en" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        href: "/",
                        children: "Home"
                    }),
                    locale === "fr" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        href: "/fr/",
                        children: "Accueil"
                    }),
                    offerPageName !== "offers" && offerPageName !== "offres" && offerPageName !== "blogue" && offerPageName !== "blog" && breadcrumbs && breadcrumbs.map(function(breadcrumb) {
                        return (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label) === "Self storage" || (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label) === "Entreposage libre service" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                            href: locale === "en" ? "/en".concat(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href, "/") : "/fr".concat(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href, "/"),
                            className: "breadcrumbs",
                            children: breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label
                        }, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                            active: true,
                            href: "".concat(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href, "/"),
                            className: "breadcrumbs",
                            children: breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.label
                        }, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.href);
                    }),
                    offerPageName && offerPageName.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        href: locale === "en" ? "/en/".concat(offerPageName, "/") : "/fr/".concat(offerPageName, "/"),
                        children: offerPageName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Item */ .Z.Item, {
                        active: true,
                        children: (ref = lastCrumb[0]) === null || ref === void 0 ? void 0 : ref.label
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumbs);


/***/ }),

/***/ 11154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ portable_business; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/breadcrumbs/breadcrumb.tsx
var breadcrumb = __webpack_require__(5553);
// EXTERNAL MODULE: ./src/components/callback-modal/requestcallback-modal.tsx + 1 modules
var requestcallback_modal = __webpack_require__(13022);
// EXTERNAL MODULE: ./src/components/portable-storage/moving/how-storage-works.tsx
var how_storage_works = __webpack_require__(24276);
// EXTERNAL MODULE: ./src/components/portable-storage/moving/price/pricing.tsx + 1 modules
var pricing = __webpack_require__(89891);
// EXTERNAL MODULE: ./src/components/utility.ts
var utility = __webpack_require__(55088);
;// CONCATENATED MODULE: ./src/components/portable-business/project-org.tsx



var ProjectOrg = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var projectTitle = props === null || props === void 0 ? void 0 : props.projectTitle;
    var projectDesc = props === null || props === void 0 ? void 0 : props.projectDesc;
    var projectData = props === null || props === void 0 ? void 0 : props.projectData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "sv-project-organization",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "section-heading",
                children: projectTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: browser_default().sanitize(projectDesc)
                        }
                    }),
                    (projectData === null || projectData === void 0 ? void 0 : projectData.Title) || "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        sizes: "(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1200px",
                        src: projectData === null || projectData === void 0 ? void 0 : (ref = projectData.Background_Image) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url,
                        alt: projectData === null || projectData === void 0 ? void 0 : (ref3 = projectData.Background_Image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.url,
                        className: "project-img img-fluid",
                        width: "1200",
                        height: "371"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var project_org = (ProjectOrg);

;// CONCATENATED MODULE: ./src/components/portable-business/index.tsx











var PortableBusinessComponent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
    var router = (0,next_router.useRouter)();
    var pathWithoutQuery = router.asPath.split("?")[0];
    var title = (ref2 = props === null || props === void 0 ? void 0 : (ref = props.portResData) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Section[0]) === null || ref2 === void 0 ? void 0 : ref2.Title;
    var subTitle = (ref5 = props === null || props === void 0 ? void 0 : (ref3 = props.portResData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.Section[0]) === null || ref5 === void 0 ? void 0 : ref5.Sub_Title;
    var howWorksTitle = (ref8 = props === null || props === void 0 ? void 0 : (ref6 = props.portResData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.Section[1]) === null || ref8 === void 0 ? void 0 : ref8.Title;
    var howWorksData = (ref11 = props === null || props === void 0 ? void 0 : (ref9 = props.portResData) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.Section[2]) === null || ref11 === void 0 ? void 0 : ref11.Cards;
    var projectTitle = (ref14 = props === null || props === void 0 ? void 0 : (ref12 = props.portResData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : ref13.Section[3]) === null || ref14 === void 0 ? void 0 : ref14.Title;
    var projectDesc = (ref17 = props === null || props === void 0 ? void 0 : (ref15 = props.portResData) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.attributes) === null || ref16 === void 0 ? void 0 : ref16.Section[3]) === null || ref17 === void 0 ? void 0 : ref17.Description;
    var projectData = props === null || props === void 0 ? void 0 : (ref18 = props.portResData) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.attributes) === null || ref19 === void 0 ? void 0 : ref19.Section[4];
    var priceValue = props === null || props === void 0 ? void 0 : props.priceValue;
    var priceTitle = (ref22 = props === null || props === void 0 ? void 0 : (ref20 = props.portResData) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.attributes) === null || ref21 === void 0 ? void 0 : ref21.Section[5]) === null || ref22 === void 0 ? void 0 : ref22.Title;
    var priceData = props === null || props === void 0 ? void 0 : (ref23 = props.portResData) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Section[6];
    var breadCrumbUrlList = (0,utility/* generateDynamicBCLD */.W_)(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sv-page-content sv-ps-business-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-xl custom-container px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "hero-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hero-banner ps-business-banner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                sizes: "(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px",
                                src: (ref29 = (ref27 = props === null || props === void 0 ? void 0 : (ref25 = props.portResData) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.attributes) === null || ref26 === void 0 ? void 0 : ref26.Section[0]) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.Background_Image) === null || ref28 === void 0 ? void 0 : ref28.data.attributes) === null || ref29 === void 0 ? void 0 : ref29.url,
                                alt: ((ref34 = (ref32 = props === null || props === void 0 ? void 0 : (ref30 = props.portResData) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.attributes) === null || ref31 === void 0 ? void 0 : ref31.Section[0]) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.Background_Image) === null || ref33 === void 0 ? void 0 : ref33.data.attributes) === null || ref34 === void 0 ? void 0 : ref34.alternativeText) || ((ref39 = (ref37 = props === null || props === void 0 ? void 0 : (ref35 = props.portResData) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.attributes) === null || ref36 === void 0 ? void 0 : ref36.Section[0]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.Background_Image) === null || ref38 === void 0 ? void 0 : ref38.data.attributes) === null || ref39 === void 0 ? void 0 : ref39.name),
                                className: "banner-img",
                                width: "1280",
                                height: "516"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "banner-content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-lg-12 col-md-12 col-sm-12 m-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: browser_default().sanitize(subTitle)
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb["default"], {
                        path: pathWithoutQuery
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                        itemListElements: breadCrumbUrlList
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(how_storage_works/* default */.Z, {
                howWorksTitle: howWorksTitle,
                howWorksData: howWorksData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(project_org, {
                projectTitle: projectTitle,
                projectDesc: projectDesc,
                projectData: projectData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing/* default */.Z, {
                priceTitle: priceTitle,
                priceData: priceData,
                priceValue: priceValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(requestcallback_modal["default"], {
                unitRate: priceValue,
                storeType: "ps",
                formType: ""
            })
        ]
    });
};
/* harmony default export */ var portable_business = (PortableBusinessComponent);


/***/ }),

/***/ 24276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);



var StorageWorks = function(props) {
    var title = props === null || props === void 0 ? void 0 : props.howWorksTitle;
    var data = props === null || props === void 0 ? void 0 : props.howWorksData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "sv-working-of-cubeit",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "section-heading",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sv-moving-storage-cards",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row justify-content-center",
                        children: data && (data === null || data === void 0 ? void 0 : data.length) && (data === null || data === void 0 ? void 0 : data.map(function(item) {
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-lg-4 col-md-4 col-sm-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "card sv-info-card sv-card-equal-height mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "card-header",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "card-logo-img",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: item === null || item === void 0 ? void 0 : (ref = item.Thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url,
                                                        alt: item === null || item === void 0 ? void 0 : (ref3 = item.Thumbnail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.url,
                                                        width: "61",
                                                        height: "61"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "card-title sv-card-titles",
                                                    children: item === null || item === void 0 ? void 0 : item.Title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "card-body",
                                            dangerouslySetInnerHTML: {
                                                __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize(item === null || item === void 0 ? void 0 : item.Description)
                                            }
                                        })
                                    ]
                                })
                            }, item === null || item === void 0 ? void 0 : item.id);
                        }))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StorageWorks);


/***/ }),

/***/ 89891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/components/portable-storage/moving/call-us.tsx



var CallUs = function() {
    var rcNumber = constants/* PORTABLE_CALL_NUMBER */.a3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-white text-decoration-none",
            href: "tel:".concat(rcNumber) || 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "btn as-primary-btn",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "call"
                    }),
                    ": ",
                    rcNumber
                ]
            })
        })
    });
};
/* harmony default export */ var call_us = (CallUs);

;// CONCATENATED MODULE: ./src/components/portable-storage/moving/price/pricing.tsx






var Pricing = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var priceValue = props === null || props === void 0 ? void 0 : props.priceValue;
    var title = props === null || props === void 0 ? void 0 : props.priceTitle;
    var titleNext = props === null || props === void 0 ? void 0 : (ref = props.priceData) === null || ref === void 0 ? void 0 : ref.Title;
    var parts = titleNext.split("$");
    var tagLine = props === null || props === void 0 ? void 0 : (ref1 = props.priceData) === null || ref1 === void 0 ? void 0 : ref1.Tag_line;
    var desc = props === null || props === void 0 ? void 0 : (ref2 = props.priceData) === null || ref2 === void 0 ? void 0 : ref2.Description;
    var imgurl = props === null || props === void 0 ? void 0 : (ref3 = props.priceData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Image) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : ref6.url;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-xl custom-container px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "section-heading",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sv-portable-storage-pricing",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row align-items-center justify-content-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-lg-6 col-md-6 col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        sizes: "(max-width: 375px) 250px, (max-width: 576px) 375px, (max-width: 768px) 325px, (max-width: 992px) 430px, (max-width: 1280px) 465px",
                                        src: imgurl,
                                        className: "ps-cubeit-container-img img-fluid",
                                        alt: (props === null || props === void 0 ? void 0 : (ref7 = props.priceData) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Image) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.alternativeText) || (props === null || props === void 0 ? void 0 : (ref11 = props.priceData) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Image) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : ref14.name),
                                        width: "466",
                                        height: "357"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-lg-6 col-md-6 col-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                            className: "sv-grey-medium-text mt-4 mt-lg-0 mt-md-0",
                                            children: [
                                                parts[0],
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        locale === "en" && "$",
                                                        priceValue,
                                                        locale === "fr" && " $"
                                                    ]
                                                }),
                                                " ",
                                                parts[1]
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "sv-road-grey-para sv-large-font",
                                            children: tagLine
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(desc)
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-6 col-md-12 col-sm-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(call_us, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-6 col-md-12 col-sm-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        className: "btn as-secondary-btn ms-lg-2",
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target": "#requestCallbackModal",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "callMeBack"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var pricing = (Pricing);


/***/ })

}]);